import { GetCategoryQuery_category_Category } from '__generated__/queries-recipe';

const NEW_CATEGORY_ID = 'NEW_CATEGORY_ID';

export const getEmptyCategory = (
  brandKey: string,
): GetCategoryQuery_category_Category => ({
  id: NEW_CATEGORY_ID,
  brandKey,
  title: '',
  updatedAt: '',
  createdAt: '',
  children: [],
  level: 0,
});
